define('gigaset_csp/components/compatibility/byfeatures',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/components/PubSubHub",
	"cartware/jquery/bem",
	"gigaset/spinner",
	"shoptheme/components/tracking"
], function(
	$,
	_,
	Component,
	PubSubHub,
	BEM,
	Spinner
) {
	return Component.create({

		block: null,
		form: null,
		product: null,
		productSelect: null,
		functions: null,
		functionsSelect: null,
		productImage: null,
		productData: null,
		resultListContainer: null,
		resultListTemplate: null,
		xhrCache: null,

		modeWrapper: null,
		modeSelect: null,
		modeInput: null,
		mode: null,

		$init: function() {
			this.block = BEM.block("csp-compatibility-byfeatures");
			this.form = this.block.getElements("form");

			this.productSelect = this.block.getElements("productSelect");
			this.functionsSelect = this.block.getElements("functionsSelect");

			this.productImage = this.block.getElements("product-image");
			this.productImage.attr('data-default-src', this.productImage.attr('src'));

			var productDataId = "productData_" + this.block.find("[data-products-id]").data("products-id");
			this.productData = productDataId in window ? window[productDataId] : {};

			this.resultListContainer = BEM.block("csp-compatibility-productresult");
			this.resultListTemplate = _.template(this.block.find('[data-template="resultList"]').html());

			this.modeWrapper = this.block.getElements("mode-wrapper");
			this.modeSelect = this.block.getElements("modeSelect");
			this.modeInput = this.block.getElements("modeInput");

			this.xhrCache = {};

			this.bindEvents();
			this.parseUrl();
			this.setImage();
			$(window).on('hashchange', $.proxy(this.parseUrl, this));
		},

		parseUrl: function() {
			var urlMatches = /#(.+)/.exec(document.location);
			var change = false;

			if (urlMatches) {
				$.each(urlMatches[1].split("&"), $.proxy(function(i, fragment) {
					var parts = /(.+?)=([^&=]+)/.exec(fragment);

					if (!parts) return;

					if (parts[1] === "product") {
						change = true;
						this.setProductInternal(parts[2]);
					} else if (parts[1] === "functions") {
						change = true;
						this.setFunctionsInternal((parts[2] || "").split(","));
					} else if (parts[1] === "mode") {
						change = true;
						this.setModeInternal(parts[2]);
					}
				}, this));

				if (change) {
					this.onChange();
				}
			}
		},

		bindEvents: function() {
			this.productSelect.on("change", $.proxy(function(e, preventLoop) {
				if (preventLoop) return;
				this.setProduct(this.productSelect.val());
			}, this));

			this.modeSelect.on("change", $.proxy(function(e, preventLoop) {
				preventLoop|| this.setMode(this.modeSelect.val());
			}, this));

			this.functionsSelect.on("change", $.proxy(function(e, preventLoop) {
				preventLoop|| this.setFunctions(this.functionsSelect.val());
			}, this));
		},

		setProduct: function(value) {
			this.setUrlHash({
				product: value
			});
			this.setImage();
			return this;
		},

		setImage: function() {
			if (this.productSelect.val() && this.productData[this.productSelect.val()].image) {
				this.productImage.attr("src", this.productData[this.productSelect.val()].image);
			} else {
				this.productImage.attr("src", this.productImage.attr('data-default-src'));
			}
		},

		setFunctions: function(value) {
			this.setUrlHash({
				functions: value
			});
			return this;
		},

		setMode: function(value) {
			this.setUrlHash({
				mode: value
			});
			return this;
		},

		setProductInternal: function(value) {
			this.productSelect.val(value).trigger("change", true);
			this.product = value in this.productData ? this.productData[value] : null;
			this.determineMode();
			return this;
		},

		setFunctionsInternal: function(value) {
			this.functionsSelect.val(value).trigger("change", true);
			this.functions = value.sort();
			return this;
		},

		setModeInternal: function(value) {
			this.modeSelect.val(value).trigger("change", true);
			this.modeInput.val(value);
			this.mode = value;
			return this;
		},

		setTypeVisibility: function(prodTypeVisibility) {
			var myElement = $('.b_csp-compatibility-byfeatures__mode-wrapper');
			myElement[prodTypeVisibility ? 'bemAddModifier' : 'bemRemoveModifier']("disabled");
		},

		determineMode: function() {
			if (this.product.base && this.product.handset) {
				// this.modeWrapper.show();
				this.setModeInternal("handset");
				this.modeSelect.attr("disabled", false);
				this.setTypeVisibility(false);
			} else {
				// this.modeWrapper.hide();

				if (this.product.handset) {
					this.setModeInternal("basestation");
				} else {
					// fallback
					this.setModeInternal("handset");
				}

				this.modeSelect.attr("disabled", true);
				this.setTypeVisibility(true);
			}

			this.modeSelect.trigger("change", true);
		},

		onChange: function() {
			this.resultListContainer.html("");

			if (this.product && this.functions && this.functions.length && this.mode) {
				var cacheKey = this.product.uid + "#" + this.mode + "#" + this.functions.sort().join("-");

				if (cacheKey in this.xhrCache) {
					this.resultListContainer.html(this.xhrCache[cacheKey]);
				} else {
					this.setLoading(true);

					$.ajax({
						type: this.form.attr("method") || "POST",
						url: this.form.attr("action"),
						data: this.form.serialize()
					}).then(_.bind(function(results) {
						var html = 'An error occurred';

						if ("undefined" !== typeof window.Translator && window.Translator.translate) {
							html = window.Translator.translate(html);
						}

						if ($.isArray(results)) {
							html = this.resultListTemplate({
								results: results
							});
						}

						this.setLoading(false);
						this.xhrCache[cacheKey] = html;
						this.resultListContainer.html(html);
					}, this));
				}

				this.registerProductCombination();
			}
		},

		setLoading: function(status) {
			// this.resultListContainer[status ? "addClass" : "removeClass"]("loading");
			Spinner[status ? "add" : "remove"](this.block);
		},

		setUrlHash: function(values) {
			var hash = window.location.hash,
				originalHash = hash;

			_.forEach(values, function(value, key) {
				var regex = new RegExp(key + "=[^&=]+");

				if (_.isArray(value)) {
					value = value.join(",");
				}

				if (regex.match(hash)) {
					if (null === value) {
						hash = hash.replace(regex, "");
					} else {
						hash = hash.replace(regex, key + "=" + value);
					}
				} else {
					if (value !== null) {
						hash += hash.substr(0, 1) === "#" ? "&" : "#";
						hash += key + "=" + value;
					}
				}
			});

			hash = hash.replace(/&$/, ""); // strip trailing "&"

			if (hash !== originalHash) {
				window.location.hash = hash;
			}
		},

		registerProductCombination: function () {
			var productLabel = this.productSelect.find("option:selected").text();
			var functionLabels = this.functionsSelect.find("option:selected").map(function() { return $(this).text(); }).get();


			PubSubHub.emit("csp.compatibility.byfeatures.view", {
				product: productLabel,
				functions: functionLabels
			});
		}
	});
});
